import { BaseMapper } from '@ps/utils';
import { FusionStats } from '@ps/survey-utils';

import { FusionStatsDto } from './fusion.dto';

export class FusionStatsMapper extends BaseMapper<FusionStatsDto, FusionStats> {
  public fromDto(dto: FusionStatsDto): FusionStats {
    return {
      slots: dto.slots,
      secondarySlots: dto.secondarySlots,
      score: dto.score,
    };
  }
}
